import { RevenueSharingItemDetailPage } from "@/features/revenue-sharing/pages/RevenueSharingItemDetailPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
	"/admin/revenue-sharing/$id/detail/$detailId",
)({
	// Keep the active tab in the URL (?tab=) so refresh + link-sharing preserve it.
	validateSearch: (search: Record<string, unknown>): { tab?: string } => ({
		tab: typeof search.tab === "string" ? search.tab : undefined,
	}),
	beforeLoad({ context }) {
		if (
			!context.authAdapter.can({
				permissions: ["revenue_sharing.view"],
			})
		) {
			throw redirect({ to: "/403" });
		}
	},
	component: RevenueSharingItemDetailPage,
});
